import { HTMLAttributes } from 'react';
import { useTranslation } from '@sib/i18n';
import { Button, Input } from '@sib/ui';
import { Search } from '@sib/ui/icons';
import { useUIContext } from '../../UIContext';
import { UserMenu } from './UserMenu';

export interface TopBarProps extends HTMLAttributes<HTMLElement> {}

export const TOPBAR_HEIGHT = 66;

export const TopBar = ({ ...props }: TopBarProps) => {
  const { setFullscreenMode, fullscreenMode } = useUIContext();
  const { t } = useTranslation();

  return (
    <header
      className="fixed top-0 right-0 left-0 z-50 flex w-[100vw] items-center border-b bg-white pr-6 pl-3 shadow-md"
      style={{ height: TOPBAR_HEIGHT }}
      {...props}
    >
      <div className="flex flex-[1_1] items-center gap-2">
        <Button
          onClick={() => setFullscreenMode(!fullscreenMode)}
          variant="outline"
          className="w-38"
        >
          {t(
            fullscreenMode
              ? 'components.topbar.exitFullscreen'
              : 'components.topbar.enterFullscreen'
          )}
        </Button>
        <Input
          startAdornment={<Search className="size-4" />}
          className="h-9 w-full max-w-3/10"
          placeholder={t('components.topbar.searchPlaceholder')}
          fullWidth
        />
      </div>
      <UserMenu />
    </header>
  );
};
